.chatContainer {
    width: 100%;
    height: 100%;
    transition: all 0.4s ease-in-out;
    flex: 1;
    justify-content: center;
    view-transition-name: dashboard;
}

.textareaInput {
    padding: 1rem;
    border: none !important;
    outline: none !important;
    scrollbar-color: var(--mantine-color-gray-5) var(--mantine-color-gray-1);
    scrollbar-width: thin;
    &::placeholder {
        color: var(--mantine-color-gray-6);
    }
}

.textareaWrapper {
    border: none !important;
    outline: none !important;
    background: red;
    overflow: hidden;
    border-radius: calc(var(--mantine-radius-lg));
}
